<template>
  <div class="p-8 bg-white">
    <h1 class="text-2xl my-8">
      Widgets
    </h1>
    <div>
      <VPButton
        component="router-link"
        :to="{ name: 'WidgetConfigNew' }"
        class="px-4 py-2 inline-block cursor-pointer"
        style="max-width: 100%"
      >
        Add new widget configuration
      </VPButton>

      <div class="table p-4">
        <div class="table-header-group">
          <div class="table-row">
            <div class="table-cell">
              Description
            </div>
            <div class="table-cell">
              Loader URL
            </div>
            <div class="table-cell">
              Embed code
            </div>
            <div class="table-cell text-right">
              Actions
            </div>
          </div>
        </div>

        <div class="table-row-group">
          <div
            v-for="widget in widgets"
            :key="widget.id"
            class="table-row hover:bg-vp-base-300 transition-all"
          >
            <div class="table-cell">
              {{ widget.description }}
            </div>
            <div class="table-cell">
              {{ widget.loaderUrl }}
            </div>
            <div class="table-cell">
              <div class="flex items-center gap-2 justify">
                <VPButton
                  variant="text"
                  title="Copy to clipboard"
                  @click="copyEmbed(widget)"
                >
                  <ContentCopy />
                </VPButton>
                <div class="overflow-y-scroll max-w-xs">
                  <pre>{{ embedCode(widget) }}</pre>
                </div>
              </div>
            </div>
            <div class="table-cell text-right">
              <VPButton
                component="router-link"
                title="Duplicate"
                :to="{ name: 'WidgetConfigDuplicate', params: { widgetId: widget.id } }"
                variant="text"
                class="inline-block cursor-pointer py-1 px-2"
                height="auto"
              >
                <ContentDuplicate />
              </VPButton>

              <VPButton
                component="router-link"
                title="Edit"
                :to="{ name: 'WidgetConfigEdit', params: { widgetId: widget.id } }"
                variant="text"
                class="inline-block cursor-pointer py-1 px-2"
                height="auto"
              >
                <Pencil />
              </VPButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VPButton from '@/components/form/VPButton.vue';
import { Pencil, ContentCopy, ContentDuplicate } from 'mdue';
import copy from 'copy-to-clipboard';
import { useWidgetsStore } from '@/stores/widgets';
import { useRootStore } from '@/stores/root';
import { computed } from 'vue';
import type { WidgetConfig } from '@/types/WidgetConfig';
import { useToast } from 'vue-toastification';

const rootStore = useRootStore();
const widgetsStore = useWidgetsStore();
const toast = useToast();

widgetsStore.fetchWidgets(rootStore.currentAccountId);

const widgets = computed(() => widgetsStore.widgets);

const embedCode = (widget: WidgetConfig): string => {
  return '<script src="' + widget.embedUrl + '"></s' + 'cript>';
};

const copyEmbed = (widget: WidgetConfig) => {
  const text = embedCode(widget);
  copy(text);
  toast.success(`Widget "${widget.description}"'s embed code has been copied to clipboard!`);
};
</script>
